import React from "react";
import { Link } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

interface MobileUserProfileProps {
  /**
   * Optional callback to close the mobile menu when a link is clicked
   */
  onLinkClick?: () => void;
}

/**
 * Reusable mobile user profile component.
 * Displays the user's name and logout button in mobile menus.
 */
export default function MobileUserProfile({
  onLinkClick,
}: MobileUserProfileProps) {
  const auth = useAuth();

  if (!auth.user) {
    return null;
  }

  return (
    <div className="admin-nav-mobile-user">
      <div className="admin-nav-mobile-user-name">
        {auth.user.name || auth.user.email}
      </div>
      <Link
        to="/logout"
        className="admin-nav-mobile-link"
        onClick={onLinkClick}
      >
        <i className="bi bi-box-arrow-right me-2" />
        Logout
      </Link>
    </div>
  );
}
